import { useSelector } from 'react-redux';
import { ProjectId } from 'api/models';
import { FieldOption, StatusGroup } from 'api/tasks';
import { Filter } from 'components/molecules/filters/types';
import { QueryCombinerType } from 'components/organisms/tasks/combiner';
import { SingleSelectField } from 'components/organisms/tasks/fields';
import { SelectFilterOperationType } from 'components/organisms/tasks/filters/select';
import { getFilterFunction } from 'components/organisms/tasks/get-filter-function';
import { RootState } from 'data';
import { FieldsStore, TaskField } from 'stores/fields';
import { Task, TasksStore } from 'stores/tasks';

export const getBlockedTaskFilter = (
  taskFields: Record<string, TaskField>,
): Filter => ({
  criteria: [taskFields.status as SingleSelectField]
    .filter(Boolean)
    .map((field) => ({
      field,
      type: SelectFilterOperationType.IsOneOf,
      value: field.metaData.options
        .filter(
          (x) => (x as FieldOption<StatusGroup>).group === StatusGroup.Blocked,
        )
        .map(({ value }) => value),
    })),
  type: QueryCombinerType.All,
});

export const useBlockedTasks = (projectId: number): Task[] => {
  const tasksStore = useSelector(({ tasks_v2 }: RootState) => tasks_v2);
  const tasks =
    TasksStore.ofProjectId(ProjectId(projectId))(tasksStore)[1] ?? [];
  const fieldsStore = useSelector(({ fields }: RootState) => fields);
  const task_fields: Record<string, TaskField> = {
    status: FieldsStore.getTaskFieldByName('status')(fieldsStore)[1],
  } as any;
  const filter = getFilterFunction(getBlockedTaskFilter(task_fields));

  return tasks.filter((x) => filter?.(x as any) ?? true);
};
